import { dataService } from "../services/data.services";
import { userService } from "../services/user.services";

export const CheckUserStatus = async () => {
    let user = true;

    const user1 = await dataService.GetAPI("providers/check-status");

    sessionStorage.setItem("custom-status", user1?.data?.data?.user_status);

    if (user1?.data?.data?.user_status === "inactive") {
        const browserIdValue = localStorage.getItem("arcm_trust_browser_token");

        // User is deactivated, log out the user
        user = false;
        await userService.logout();

        sessionStorage.clear();
        sessionStorage.setItem("custom-status", "inactive");
        localStorage.setItem("arcm_trust_browser_token", browserIdValue);

        setTimeout(() => {
            window.location.reload();
        }, 500);
    }

    return user;
};
